import { Flex } from '@components';
import { MenuItem, Select, SelectChangeEvent, styled } from '@mui/material';

export const COMBINED_CURRENCY = 'COMBINED';

export interface CurrencySelectorProps {
  selectedCurrency?: string;
  selectedCombinedCurrency?: string;
  availableCurrencies?: string[];
  availableCombinedCurrencies?: string[];
  handleSelectedCurrencyChange: (e: SelectChangeEvent<any>) => void;
  handleSelectedCombinedCurrencyChange: (e: SelectChangeEvent<any>) => void;
}

const Dropdown = styled(Select)(({ theme }) => ({
  '&:before': {
    borderBottom: `2px solid ${theme.palette.primary.main}`,
  },
  '&.MuiInputBase-root:hover:before': {
    borderBottom: `2.5px solid ${theme.palette.primary.main}`,
  },
}));

export const CurrencySelector: React.FC<CurrencySelectorProps> = ({
  selectedCurrency,
  selectedCombinedCurrency,
  availableCurrencies,
  availableCombinedCurrencies,
  handleSelectedCurrencyChange,
  handleSelectedCombinedCurrencyChange,
}) => {
  return (
    <Flex gap={8}>
      <Dropdown
        label=''
        variant='standard'
        value={selectedCurrency}
        onChange={handleSelectedCurrencyChange}
        sx={{}}
      >
        {availableCurrencies?.map((currency) => (
          <MenuItem value={currency}>
            {currency === COMBINED_CURRENCY ? 'Combined' : currency}
          </MenuItem>
        ))}
      </Dropdown>
      {selectedCurrency && selectedCurrency === COMBINED_CURRENCY ? (
        <Dropdown
          label=''
          variant='standard'
          value={selectedCombinedCurrency}
          onChange={handleSelectedCombinedCurrencyChange}
        >
          {availableCombinedCurrencies?.map((currency) => (
            <MenuItem value={currency}>{currency}</MenuItem>
          ))}
        </Dropdown>
      ) : null}
    </Flex>
  );
};
